import { render, staticRenderFns } from "./VExpansionPanelHeaderEditable.vue?vue&type=template&id=5c02045d&scoped=true&"
import script from "./VExpansionPanelHeaderEditable.vue?vue&type=script&lang=js&"
export * from "./VExpansionPanelHeaderEditable.vue?vue&type=script&lang=js&"
import style0 from "./VExpansionPanelHeaderEditable.vue?vue&type=style&index=0&id=5c02045d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c02045d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VExpansionPanelHeader,VFadeTransition,VIcon,VRow})
